var malaElements = document.querySelectorAll('[klaviyo-id]');
  var klaviyoIds = [];
  
  malaElements.forEach(function(element) {
      var klaviyoId = element.getAttribute('klaviyo-id');
      klaviyoIds.push(klaviyoId);
      element.removeEventListener('click', handleClick);
      element.addEventListener('click', handleClick);
  });
  
  console.log(klaviyoIds);
  function handleClick() {
      var formId = this.getAttribute('form-id');
      window._klOnsite = window._klOnsite || []; 
      window._klOnsite.push(['openForm', formId]);
  }